import React from 'react'

export const MenuContext = React.createContext(true)
export const MenuContextToggle = React.createContext(false)
export const MenuFiltered = React.createContext({})
export const MenuAppendicesFiltered = React.createContext({})
export const MenuMaterialsFiltered = React.createContext({})
export const AnnotationContext = React.createContext({})
export const SelectionContext = React.createContext({})
export const BookInfo = React.createContext({})
export const UserInfo = React.createContext({})
export const Errors = React.createContext({})
